export default __webpack_public_path__ + "static/media/hht2_sitcom_06.c2eaf9fc.png";